/*
Copyright 2024 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const FullScreenExitIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Full Screen Exit',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M6 2.5V8H.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5H8V2.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5ZM30 8V2.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5V10h7.5a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5ZM0 26.5v1a.5.5 0 0 0 .5.5H6v5.5a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5V26H.5a.5.5 0 0 0-.5.5ZM30 28h5.5a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5H28v7.5a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5Z"
    />
    <rect height="16" rx=".5" ry=".5" width="20" x="8" y="10" />
  </svg>`;
};
